const $ = jQuery;

export function exitIntent() {
    let triggered = false;

    $(document).on('mouseleave', (e) => {
        // Trigger if mouse leaves the top of the window (common exit intent)
        if (e.clientY < 0 && !triggered) {
            // Do not fire if any other modal is currently open
            const anyModalOpen = document.querySelector('.modal.show[aria-modal="true"], .modal.show[role="dialog"]');
            if (anyModalOpen) return;

            const modalElement = document.getElementById('growtypeChatLastChanceModal');

            if (modalElement) {
                triggered = true;

                // Track exit intent event
                if (typeof growtypeAnalyticsCapture === 'function') {
                    growtypeAnalyticsCapture('growtype_analytics_growtype_chat_last_chance_modal_triggered', {
                        page: window.location.pathname
                    });
                }

                $(modalElement).modal('show');
            }
        }
    });
}
